<template>
  <div id="admin">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  export default {
    name: "admin"
  }
</script>
